import { UseQueryOptions, useQueries } from "react-query";
import { IAgent, Route } from "@edgetier/watchtower-types";
import { AxiosError } from "axios";
import { axios } from "utilities/axios";

/**
 * Request an agent's details from the backend.
 * @param url Query route
 */
const requestAgent = async (url: string) => {
    const { data } = await axios.get<IAgent>(url);
    return data;
};

/**
 * Request all agents from interaction chat messages using their ids
 * @param agentIds     List of roles
 */
export const useMessagesAgents = (
    agentIds: string[],
    configuration: Omit<UseQueryOptions<IAgent, AxiosError<void>, any>, "queryKey" | "queryFn"> = {}
) => {
    const queryOptions = {
        ...configuration,
        enabled: Array.isArray(agentIds) && agentIds.length > 0,
    };

    return useQueries(
        agentIds.map((agentId) => {
            const url = Route.Agent.replace(":agentId", agentId);

            return {
                queryKey: [url],
                queryFn: () => requestAgent(url),
                ...queryOptions,
            };
        })
    );
};
